const map = {
	"./monocolor/icon-arrow-circle.svg": "./src/assets/svg/monocolor/icon-arrow-circle.svg",
	"./monocolor/icon-arrow-left.svg": "./src/assets/svg/monocolor/icon-arrow-left.svg",
	"./monocolor/icon-arrow-long.svg": "./src/assets/svg/monocolor/icon-arrow-long.svg",
	"./monocolor/icon-arrow-right-top.svg": "./src/assets/svg/monocolor/icon-arrow-right-top.svg",
	"./monocolor/icon-arrow-right.svg": "./src/assets/svg/monocolor/icon-arrow-right.svg",
	"./monocolor/icon-arrow.svg": "./src/assets/svg/monocolor/icon-arrow.svg",
	"./monocolor/icon-check.svg": "./src/assets/svg/monocolor/icon-check.svg",
	"./monocolor/icon-close.svg": "./src/assets/svg/monocolor/icon-close.svg",
	"./monocolor/icon-edit.svg": "./src/assets/svg/monocolor/icon-edit.svg",
	"./monocolor/icon-insta.svg": "./src/assets/svg/monocolor/icon-insta.svg",
	"./monocolor/icon-plus.svg": "./src/assets/svg/monocolor/icon-plus.svg",
	"./monocolor/icon-search.svg": "./src/assets/svg/monocolor/icon-search.svg",
	"./monocolor/icon-tg.svg": "./src/assets/svg/monocolor/icon-tg.svg",
	"./monocolor/icon-vk.svg": "./src/assets/svg/monocolor/icon-vk.svg",
	"./monocolor/icon-whatsapp.svg": "./src/assets/svg/monocolor/icon-whatsapp.svg",
	"./monocolor/icon-youtube.svg": "./src/assets/svg/monocolor/icon-youtube.svg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync recursive \\.svg$";